const BROKEN_CONNECTION_PROPS = {
  subTextProps: { color: '#B74242', fontSize: '12px', lineHeight: '18px' },
};
const BROKEN_CONNECTION_BG_COLOR = 'rgba(183, 66, 66, 0.05) !important';

export { BROKEN_CONNECTION_PROPS, BROKEN_CONNECTION_BG_COLOR };
